/**
 * ローディング画面で各stateの保存状態を管理
 * デフォルトはfalseで、stateに情報保存済みの場合はtrueに更新
 * getters/readiedCount()にて、true（保存済み）の数を算出し、プログレスバーの進行を制御
 */
export default {
  namespaced: true,
  state: {
    event: false,
    dm: false,
    hall: false,
    corner: false,
    room: false,
    participant: false,
    authUser: false
  },
  getters: {
    countAll: state => {
      return Object.keys(state).length
    },
    readiedCount: state => {
      let result = 0
      _.forEach(state, function(value) {
        if (value) {
          result++
        }
      })

      return result
    }
  },
  mutations: {
    readyEvent(state) {
      state.event = true
    },
    readyDm(state) {
      state.dm = true
    },
    readyHall(state) {
      state.hall = true
    },
    readyCorner(state) {
      state.corner = true
    },
    readyRoom(state) {
      state.room = true
    },
    readyParticipant(state) {
      state.participant = true
    },
    readyUser(state) {
      state.authUser = true
    },
    reset(state) {
      state.participant = false
      state.authUser = false
    }
  },
  actions: {
    readyEvent(state) {
      state.commit("readyEvent")
    },
    readyDm(state) {
      state.commit("readyDm")
    },
    readyHall(state) {
      state.commit("readyHall")
    },
    readyCorner(state) {
      state.commit("readyCorner")
    },
    readyRoom(state) {
      state.commit("readyRoom")
    },
    readyParticipant(state) {
      state.commit("readyParticipant")
    },
    readyUser(state) {
      state.commit("readyUser")
    },
    /**
     * 遷移毎に更新されるparticipantとauthUserをfalse（未保存状態）に更新
     * @param state
     */
    reset(state) {
      state.commit("reset")
    }
  }
}
